import React, { useState } from "react";
import avatar from "../assets/images/my-avatar.png";
import { IoMailOutline, IoPhonePortraitOutline, IoCalendarOutline, IoLocationOutline, IoChevronDown, IoLogoFacebook, IoLogoTwitter, IoLogoInstagram } from "react-icons/io5";

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <aside className={`sidebar${isOpen ? " active" : ""}`} data-sidebar>
            <div className="sidebar-info">
                <figure className="avatar-box">
                    <img src={avatar} alt="Richard hanrick" width="80" />
                </figure>
                <div className="info-content">
                    <h1 className="name" title="Richard hanrick">Richard hanrick</h1>
                    <p className="title">Web developer</p>
                </div>
                <button className="info_more-btn" data-sidebar-btn onClick={() => setIsOpen(!isOpen)}>
                    <span>{isOpen ? "Hide Contacts" : "Show Contacts"}</span>
                    <IoChevronDown size={20} style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }} />
                </button>
            </div>
            <div className={`sidebar-info_more${isOpen ? " active" : ""}`}>
                <div className="separator"></div>
                <ul className="contacts-list">
                    <li className="contact-item">
                        <div className="icon-box">
                            <IoMailOutline size={24} />
                        </div>
                        <div className="contact-info">
                            <p className="contact-title">Email</p>
                            <a href="mailto:richard@example.com" className="contact-link">richard@example.com</a>
                        </div>
                    </li>
                    <li className="contact-item">
                        <div className="icon-box">
                            <IoPhonePortraitOutline size={24} />
                        </div>
                        <div className="contact-info">
                            <p className="contact-title">Phone</p>
                            <a href="tel:+12133522795" className="contact-link">+1 (213) 352-2795</a>
                        </div>
                    </li>
                    <li className="contact-item">
                        <div className="icon-box">
                            <IoCalendarOutline size={24} />
                        </div>
                        <div className="contact-info">
                            <p className="contact-title">Birthday</p>
                            <time dateTime="1982-06-23">June 23, 1982</time>
                        </div>
                    </li>
                    <li className="contact-item">
                        <div className="icon-box">
                            <IoLocationOutline size={24} />
                        </div>
                        <div className="contact-info">
                            <p className="contact-title">Location</p>
                            <address>Sacramento, California, USA</address>
                        </div>
                    </li>
                </ul>
                <div className="separator"></div>
                <ul className="social-list">
                    <li className="social-item">
                        <button className="social-link" type="button">
                            <IoLogoFacebook size={24} />
                        </button>
                    </li>
                    <li className="social-item">
                        <button className="social-link" type="button">
                            <IoLogoTwitter size={24} />
                        </button>
                    </li>
                    <li className="social-item">
                        <button className="social-link" type="button">
                            <IoLogoInstagram size={24} />
                        </button>
                    </li>
                </ul>
            </div>
        </aside>
    );
};

export default Sidebar;